import './dashboard.less';

import classNames from 'classnames';
import React from 'react';
import {Link, browserHistory} from 'react-router';
import DashBoardHeader from '../header_dashboard/dashboard_header';
import MediaQuery from 'react-responsive';
import dashboardActions from './dashboard_actions';
import {routerActions} from 'react-router-redux';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import authActions from '../auth/auth_actions';
import ShowError from '../components/error/show_error';
import CONSTANTS from '../common_constants';
import moment from 'moment';
import LoggedinFooter from '../footer/loggedin_footer';
import ModalPopUp from '../components/modalPopUp/modalPopUp';
import LogoutPopUp from '../components/logoutPopUp/logout_pop_up';
import ShipmentDetail from './shipment_detail';
import EmptyShipments from './empty_shipment';
import cookies from '../util/cookie';

class Shipment extends React.Component{
  constructor(props){
    super(props);
    this.state = {}
  }

  render(){

    const {props, state} = this;
    let {shipments} = props;
    const no_reciving_img = "../../public/images/dashboard/no_shipments.png";
    return(
      <div className = "shipment-detail-wrap">
        {
          shipments.inProgress && shipments.inProgress.length>0 && shipments.inProgress.map( (shipment,index) => {
            return(
              <div className="progress-packages">
                <ShipmentDetail
                  shipment = {shipment}
                  key={index}
                  isReceiving={true}
                  isShipper = {false}
                  backTo = {'receiving'} />
                  {shipment.shipmentType == 2 && shipment.carrierProfileImageUrl && !shipment.isBlocked &&
                    <MediaQuery query='(max-width: 767px)' >
                      <img className="request-profile-img-url" src={shipment.carrierProfileImageUrl} />
                    </MediaQuery>
                  }
              </div>
            )
          })
        }
        {shipments.delivered && shipments.delivered.length > 0 && <h2 className = "shipment-package-header">Delivered</h2>}
        {
          shipments.delivered && shipments.delivered.length > 0 && shipments.delivered.map( (shipment,index) => {
            return(
              <div className="delivered-packages">
                <ShipmentDetail
                  delivered={true}
                  shipment = {shipment}
                  isReceiving={true}
                  key={index}
                  isShipper = {false}
                  backTo = {'receiving'}/>
                {shipment.shipmentStatus === 9 && <span className="delivered-packages-icon status-img"></span>}
                {shipment.shipmentType == 2 && shipment.carrierProfileImageUrl && !shipment.isBlocked &&
                  <MediaQuery query='(max-width: 767px)' >
                    <img className="request-profile-img-url" src={shipment.carrierProfileImageUrl} />
                  </MediaQuery>
                }
              </div>
            )
          })
        }
        {
          (shipments.delivered && shipments.delivered.length == 0 && shipments.inProgress && shipments.inProgress.length == 0) &&
            <EmptyShipments title={"Nothing to Receive"} info={"When someone sends you a shipment they will appear here."} imgURL ={no_reciving_img}/>
        }
      </div>
    )
  }
}

class ReceivingDashBoard extends React.Component{

  constructor(props){
    super(props);
    const {dashboard} = props;

    this.state = {
      isLoading: false,
      error: '',
      isReceiving: true,
      receivingPackages: dashboard && dashboard.receivingPackages || [],
      shippingCount: dashboard && dashboard.shippingCount,
      carryingCount: dashboard && dashboard.carryingCount,
      receivingCount: dashboard && dashboard.receivingCount
    }
    this.getReceivingPackages = this.getReceivingPackages.bind(this);
  }

  logout() {
    this.props.authActions.logout().always(() => {
        cookies.delete('_sd');
        document.location.href = '/';
    });
  }

  componentWillReceiveProps(newProps) {
    if(newProps.dashboard.receivingPackages) {
      this.setState({ receivingPackages:newProps.dashboard.receivingPackages,
                      shippingCount: newProps.dashboard.shippingCount,
                      carryingCount: newProps.dashboard.carryingCount,
                      receivingCount: newProps.dashboard.receivingCount
                    });
    }
  }

  componentDidMount(){
    this.setState({isLoading: true});
    this.getReceivingPackages();
  }

  getReceivingPackages(){
    const {dashboardActions} = this.props;
    dashboardActions.getRecievingPackages().then(() => {
      this.setState({isLoading: false});
    }, (errorRes) => {
      if(errorRes.error === CONSTANTS.sessionInvalid){
        this.setState({isLoading: false})
        this.props.authActions.sessionValid(false);
        cookies.delete('_sd');
        return ;
      }
      this.setState({
        isLoading: false,
        error: errorRes.error
      })
    });
  }

  render(){
    const self = this;
    const {props, state} = this;
    const {receivingPackages, carryingCount, shippingCount, receivingCount} = state;
    let shipments = {};
    let sessionValid = true ;
    if("sessionValid" in props.authState.userData)
        sessionValid = props.authState.userData.sessionValid
    let user = {
      name: '',
      imageUrl: '',
      isVerified: ''
    };
    let isFirstTime;
    if(props.location)
       isFirstTime = props.location.query.isFirstTime;
    else
        isFirstTime = false;

    if(props.authState) {
      user.name = props.authState.userData.name;
      user.imageUrl = props.authState.userData.profileImageUrl;
      user.isVerified = props.authState.userData.isVerified;
    }

    return(
      <div className = "">
        <div className = "d-tab-wrap">
          <div className = "wrapper tabs-wrap">
            <Link to="/dashboard/i-am-shipping">
              <div className = "d-tab-elm">
                I'M SHIPPING{shippingCount>0 && <span className = "shipping-count">{shippingCount}</span>}
              </div>
            </Link>
            <Link to = "/dashboard/i-am-carrying">
              <div className = "d-tab-elm">
                I'M CARRYING{carryingCount>0 && <span className = "shipping-count">{carryingCount}</span>}
              </div>
            </Link>
            <Link to = "/dashboard/i-am-receiving">
              <div className = {classNames('d-tab-elm', {'active-nav-class' : state.isReceiving})}>
                I'M RECEIVING{receivingCount>0 && <span className = "shipping-count">{receivingCount}</span>}
              </div>
            </Link>
          </div>
        </div>
        {state.isLoading && <div className = "loader-wrapper"><div className = "loader"></div></div>}
        {state.error && <ShowError errorMessage={state.error}/>}
        <div className = "wrapper shipments-wrap">
          <Shipment
            shipments={receivingPackages}
            authState = {this.props.authState}
          />
        </div>
      </div>
    )
  }
}

ReceivingDashBoard = connect((state) => {
  return {
    dashboard: state.app.dashboard,
    authState: state.app.auth
  }
}, (dispatch) => {
  return {
    dashboardActions: bindActionCreators(dashboardActions, dispatch),
    routerActions: bindActionCreators(routerActions, dispatch),
    authActions : bindActionCreators(authActions, dispatch)
  }
})(ReceivingDashBoard);

module.exports = ReceivingDashBoard;



// WEBPACK FOOTER //
// app/dashboard/receiving_dashboard.jsx